import styled from '@emotion/styled'
import { FC } from 'react'
import { Colors, Shapes } from 'src/components/theme'
import { formatVal } from 'src/utils/number-format'
import { Divider, Typography } from '@mui/material'
import { MapSquareIcon } from 'src/components/icons/map-square'
import { User } from '@emotion-icons/boxicons-solid/User'
import { PercentageBar } from 'src/v2/components/percentage-bar'
import { PropertyDistributionItem } from 'src/v2/views/owner-reveal/sidebar/result-overlay/properties-distribution-list'

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const FooterItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${Colors.neutral300};
`

type OwnerResultFooterProps = {
  amountOfContacts: number
  amountOfParcels: number
  distributions: Record<string, number>
  propertiesDistributions?: PropertyDistributionItem[]
}
export const OwnerSummary: FC<OwnerResultFooterProps> = ({
  distributions,
  amountOfContacts,
  amountOfParcels,
  propertiesDistributions,
}) => {
  return (
    <FooterContainer>
      {amountOfContacts ? (
        <FooterItem>
          <User size={14} />
          <Typography variant="textmdm" color={Colors.neutral400}>
            {formatVal(amountOfContacts, 'short-number')}
          </Typography>
        </FooterItem>
      ) : null}
      {amountOfContacts && amountOfParcels ? <Divider orientation="vertical" flexItem variant="middle" /> : null}
      {amountOfParcels ? (
        <FooterItem>
          <MapSquareIcon size={12} />
          <Typography variant="textmdm" color={Colors.neutral400}>
            {formatVal(amountOfParcels, 'short-number')}
          </Typography>
        </FooterItem>
      ) : null}
      <Divider orientation="vertical" flexItem variant="middle" />
      <PercentageBar
        maxWidth={92}
        height={Shapes.spacing[2]}
        percentages={distributions}
        showDetails
        propertiesDistributions={propertiesDistributions}
      />
    </FooterContainer>
  )
}
